import { Component } from 'react';
import PropTypes from 'prop-types';

import { getCookiesList } from '../utils';

const storage = typeof window !== 'undefined' && window.localStorage;

export default class CookieConsent extends Component {
  static propTypes = {
    getCookiesData: PropTypes.func.isRequired,
    saveCookies: PropTypes.func.isRequired,
    shouldLoadOneTrust: PropTypes.bool,
  };

  componentDidMount() {
    const { shouldLoadOneTrust, getCookiesData } = this.props;

    if (!shouldLoadOneTrust) {
      return null;
    }

    window.addEventListener('consent.onetrust', this.onCookieConsentChanged);
    getCookiesData(this.onSuccessFetchedCookiesData);
    return false;
  }

  componentWillUnmount() {
    window.removeEventListener('consent.onetrust', this.onCookieConsentChanged);
  }

  onCookieConsentChanged = () => {
    const { saveCookies } = this.props;
    const cookiesList = getCookiesList();
    saveCookies(cookiesList);
  };

  onSuccessFetchedCookiesData = (categorization) => {
    if (storage) {
      storage.setItem('categorization', JSON.stringify(categorization));
    }
  };

  render() {
    return null;
  }
}

